export default __webpack_public_path__ + "static/media/HEY JUNE.74484ec7.otf";